var homeJobList = {
    slider: $('.home-job-list-carousel-js'),
    sliderPrevious: $('.job-list-previous-js'),
    sliderNext: $('.job-list-next-js')
};

homeJobList.slider.slick({
    arrows: false,
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }
    ]
});

homeJobList.sliderNext.on('click', function(){
   homeJobList.slider.slick('slickNext');
});
homeJobList.sliderPrevious.on('click', function(){
    homeJobList.slider.slick('slickPrev');
});

/* CategorySearch Home-top SP:
===============================*/
homeSearch_sp = {
    categoryLink: $('.search-container_sp .category-links'),
    searchPlusModal_sp: $('.searchPlusModal_sp'),
    btnClose: $('.btn-close')
};

homeSearch_sp.categoryLink.click(function(e) {
    e.preventDefault();
    homeSearch_sp.searchPlusModal_sp.removeClass('hidden');
    $('body').css({
        'overflow':'hidden'
    });
});
homeSearch_sp.btnClose.click(function(e){
    e.preventDefault();
    homeSearch_sp.searchPlusModal_sp.addClass('hidden');
    $('body').css({
        'overflow': 'unset'
    });
});

/* Expert Mobile Nav:
====================*/
mobileNav = {
    hamburger: $('.mobile-nav-btn'),
    navSlide: $('.nav-slide'),
    btnClose: $('.btn-close')
};

mobileNav.hamburger.click(function(e) {
    e.preventDefault();
    mobileNav.navSlide
        .removeClass('hidden')
        .css({'left':'unset'});
    $('body')
        .css({'overflow': 'hidden'})
        .addClass('fixed-overlay');
});
mobileNav.btnClose.click(function (e) {
    e.preventDefault();
    mobileNav.navSlide.addClass('hidden');
    $('body')
        .css({'overflow': 'unset'})
        .removeClass('fixed-overlay');
});